import { useState } from "react";

const STORAGE_KEY = "invoices.emailCustomerOnConfirm";

function readChoice(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * The "email the customer" tick next to every confirm button. Starts unticked,
 * then remembers the last choice in this browser. Storage can be missing or
 * blocked; the tick then simply starts unticked every time.
 */
export default function useRememberedSendChoice(): [
  boolean,
  (send: boolean) => void
] {
  const [send, setSend] = useState(readChoice);

  const choose = (value: boolean) => {
    setSend(value);
    try {
      window.localStorage.setItem(STORAGE_KEY, value ? "1" : "0");
    } catch {
      // Not remembered, but the tick still works for this session.
    }
  };

  return [send, choose];
}
